import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@reservamos/elements';
import './BackButton.scss';
import i18n from 'i18next';

/**
 * BackButton component.
 * @param {Function} onClick - Click handler function
 * @param {boolean} isRoundTripWithOpenDeparture - Whether this is a round trip with open departure ticket
 * @param {boolean} isRoundTripWithBothOpen - Whether this is a round trip with both departure and return open tickets
 * @returns {JSX} React component
 */
const BackButton = ({ onClick, isRoundTripWithOpenDeparture, isRoundTripWithBothOpen }) => {
  /**
   * Get the label text based on the trip type
   * @returns {string} The translated label text
   */
  const getLabelText = () => {
    if (isRoundTripWithBothOpen) return i18n.t('common:labels.go_to');
    if (isRoundTripWithOpenDeparture) return `${i18n.t('common:buttons.modify')}`;
    return i18n.t('common:labels.back_to');
  };

  /**
   * Get the button text based on the trip type
   * @returns {string} The translated button text
   */
  const getButtonText = () => {
    if (isRoundTripWithOpenDeparture) return i18n.t('common:buttons.return_schedule');
    return i18n.t('common:buttons.schedules');
  };

  return (
    <div
      className="rvui-back-container"
      title={i18n.t('common:tooltip.back_to_schedules')}
      onClick={onClick}
    >
      <Text color="grayMedium" size="S">
        {getLabelText()}
      </Text>
      <div className="rvui-back-button">
        <Text size="S" weight="bold" elementType="span">
          {getButtonText()}
        </Text>
      </div>
    </div>
  );
};

BackButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isRoundTripWithOpenDeparture: PropTypes.bool,
  isRoundTripWithBothOpen: PropTypes.bool,
};

export default BackButton;
